import Skynet from 'skynet';
export default new Skynet('');
